<template>
  <v-tour :name="name" :steps="steps">
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          class="white elevation-8 rounded text-center pa-3"
        >
          <div slot="actions" class="mt-2">
            <v-btn
              small
              @click="onNext(tour.nextStep, tour.currentStep)"
              :disabled="disabled"
              v-if="!tour.isLast"
              color="primary"
            >
              Next
            </v-btn>
            <v-btn v-else small @click="$emit('finish', true)" color="primary">
              {{ finishText }}
            </v-btn>
          </div>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    steps: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    finishText: {
      type: String,
      default: 'Finish'
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onNext (cb, step) {
      this.$emit('next', step)
      setTimeout(() => cb(), this.delay)
    }
  }
}
</script>
